module.exports = __webpack_public_path__ + "677274e146645db3fcc91a3b33e308e1.MP3";